import { Routes, Route, Navigate } from 'react-router-dom'
import Users from './pages/Users/Users'

export default function UserManagementRoutes() {
  return (
    <Routes>
      <Route path="" element={<Navigate to={'users'} />} />
      <Route path="users" element={<Users />} />
    </Routes>
  )
}
